import React from 'react';
import { FC } from 'react';

import { FormProps } from '@routes/NewOrder/model';
import { Controller } from 'react-hook-form';

import Button, { BUTTON_TYPE } from '@components/Button';
import Select from '@components/Select';
import TextArea from '@components/TextArea';
import TextInput from '@components/TextInput';

import styles from './style.module.scss';

const FormFields: FC<FormProps> = ({ control, sortedLanguages, isValid, serviceTypes, languages }) => (
  <div>
    {/* Order Id */}
    <fieldset>
      <Controller
        rules={{ required: 'The field is required' }}
        control={control}
        name={'orderId'}
        render={({ field: { name, onChange, onBlur, value }, fieldState: { error } }) => {
          return <TextInput onBlur={onBlur} name={name} label="How will you track your order?" value={value} onChange={onChange} error={error?.message} />;
        }}
      />
    </fieldset>

    {/* Source language */}
    <fieldset>
      <TextInput name={'sourceLanguage'} onChange={() => {}} label="Source language" value={languages?.sourceLanguage.value || ''} disabled />
    </fieldset>

    {/* Target languages */}
    <fieldset>
      <Controller
        rules={{ required: 'The field is required' }}
        control={control}
        name={'targetLanguages'}
        render={({ field: { name, onChange, onBlur, value }, fieldState: { error } }) => {
          return (
            <Select
              options={sortedLanguages.map(({ key, value }) => ({
                label: `${value} (${key})`,
                value: key,
              }))}
              isMulti
              hideSelectAll
              onBlur={onBlur}
              name={name}
              label="Select languages"
              value={value}
              onChange={onChange}
              error={error?.message}
            />
          );
        }}
      />
    </fieldset>

    {/* Service type */}
    <fieldset>
      <Controller
        rules={{ required: 'The field is required' }}
        control={control}
        name={'serviceType'}
        render={({ field: { name, onChange, onBlur, value }, fieldState: { error } }) => {
          return (
            <Select
              //REMOVE.
              options={(serviceTypes || []).map((s: any) => ({ value: s, label: s }))}
              onBlur={onBlur}
              name={name}
              label="Select service type"
              value={value}
              onChange={onChange}
              error={error?.message}
            />
          );
        }}
      />
    </fieldset>

    {/* Purchase order */}
    <fieldset>
      <Controller
        control={control}
        name={'purchaseOrder'}
        rules={{ maxLength: { value: 250, message: 'The field is too long' } }}
        render={({ field: { name, onChange, onBlur, value }, fieldState: { error } }) => {
          return <TextInput onBlur={onBlur} name={name} label="Purchase order" value={value} onChange={onChange} error={error?.message} maxLength={251} />;
        }}
      />
    </fieldset>

    {/* Cost center */}
    <fieldset>
      <Controller
        control={control}
        name={'cost_attribution_label'}
        rules={{ maxLength: { value: 250, message: 'The field is too long' } }}
        render={({ field: { name, onChange, onBlur, value }, fieldState: { error } }) => {
          return <TextInput onBlur={onBlur} name={name} label="Cost center" value={value} onChange={onChange} error={error?.message} maxLength={251} />;
        }}
      />
    </fieldset>

    {/* Instruction */}
    <fieldset>
      <Controller
        control={control}
        name={'instructions'}
        render={({ field: { name, onChange, onBlur, value }, fieldState: { error } }) => {
          return <TextArea onBlur={onBlur} name={name} label="Add instructions" value={value} onChange={onChange} error={error?.message} />;
        }}
      />
    </fieldset>
    <Button disabled={!isValid} htmlType={'submit'} type={BUTTON_TYPE.PRIMARY} className={styles.submitButton}>
      Send order
    </Button>
  </div>
);

export default FormFields;
